var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Base } from "../ContainerBase";
import Deque from "../SequentialContainer/Deque";
var Queue = /** @class */ (function (_super) {
    __extends(Queue, _super);
    function Queue(container) {
        if (container === void 0) { container = []; }
        var _this = _super.call(this) || this;
        _this._queue = new Deque(container);
        _this._length = _this._queue.size();
        return _this;
    }
    Queue.prototype.clear = function () {
        this._queue.clear();
        this._length = 0;
    };
    /**
     * @description Inserts element to queue's end.
     * @param element - The element you want to push to the front.
     * @returns The container length after pushing.
     */
    Queue.prototype.push = function (element) {
        this._queue.pushBack(element);
        this._length += 1;
        return this._length;
    };
    /**
     * @description Removes the first element.
     * @returns The element you popped.
     */
    Queue.prototype.pop = function () {
        if (this._length === 0)
            return;
        this._length -= 1;
        return this._queue.popFront();
    };
    /**
     * @description Access the first element.
     * @returns The first element.
     */
    Queue.prototype.front = function () {
        return this._queue.front();
    };
    return Queue;
}(Base));
export default Queue;
